import React, { Component } from 'react';
import { BrowserRouter as Router} from "react-router-dom";
import '../Styles/Main.css';
import Intro from './Intro';
import Header from './Header';
import Content from './Content';


export default class Main extends Component {
    render() {
        return (
            <Router>
                <div className="container">
                    <Header />
                    <div className="body">
                        <Content />
                    </div>
                    {/* <div className="footer">
                        <div>
                            <div id="footer_logo">LOGO</div>
                            <div id="contactUs">Contact Us: xxxx@gmail.com</div>
                        </div>
                    </div>                 */}
                </div>
            </Router>
        )
    }
}
